import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_ALLERGEN_MUTATION } from '../graphql/mutations'
import { DELETE_ALLERGEN } from '../redux/action-types'

const useDeleteAllergenMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.allergens.allergens)

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_ALLERGEN_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_ALLERGEN,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteAllergenMutation
